import { StyleSheet, color, containerMaxWidth } from '@coursera/coursera-ui';

export default StyleSheet.create({
  HeaderContainer: {
    backgroundColor: color.white,
    boxShadow: '0px 2px 4px var(--cds-color-darken-50)',
    position: 'relative',
  },
  ListContainer: {
    backgroundColor: color.bgGray,
    paddingBottom: '96px', // footer height
  },
  FooterContainer: {
    backgroundColor: color.white,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    filter: 'drop-shadow(0px -2px 6px var(--cds-color-darken-100))',
  },
  ContainerContent: {
    maxWidth: containerMaxWidth.xl,
    margin: '0 auto',
  },
  SkillSetCard: {
    maxWidth: 'calc(50% - 12px)',
    width: '100%',
    marginBottom: 24,
    ':nth-child(odd)': {
      marginRight: 24,
    },
  },
});
